var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 147,
    height: 147,
    viewBox: "0 0 147 147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_222",
    x: 0,
    y: 0,
    width: 147,
    height: 147,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8482",
    "data-name": "Group 8482",
    transform: "translate(-612 -898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6271",
    "data-name": "Group 6271",
    transform: "translate(14 -40)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 598, 938)",
    filter: "url(#Ellipse_222)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_222-2",
    "data-name": "Ellipse 222",
    cx: 64.5,
    cy: 64.5,
    r: 64.5,
    transform: "translate(9 6)",
    fill: "rgba(255,255,255,0.9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8481",
    "data-name": "Group 8481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-mic",
    "data-name": "Icon feather-mic",
    transform: "translate(654.508 929.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9751",
    "data-name": "Path 9751",
    d: "M23.782,1.5A10.282,10.282,0,0,0,13.5,11.782V39.2a10.282,10.282,0,1,0,20.565,0V11.782A10.282,10.282,0,0,0,23.782,1.5Z",
    transform: "translate(7.71)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9752",
    "data-name": "Path 9752",
    d: "M55.485,15v6.855a23.992,23.992,0,1,1-47.985,0V15",
    transform: "translate(0 17.347)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9753",
    "data-name": "Path 9753",
    d: "M18,28.5V42.21",
    transform: "translate(13.492 34.694)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9754",
    "data-name": "Path 9754",
    d: "M12,34.5H39.42",
    transform: "translate(5.782 42.404)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicNew);
export default __webpack_public_path__ + "static/media/mic-new.69de7d88d7bf0cd2bbd6d4f7d6052df1.svg";
export { ForwardRef as ReactComponent };